<template>
  <a-layout-sider :trigger="null" collapsible v-model="collapsed">
    <a-menu
      theme="dark"
      mode="inline"
      :defaultSelectedKeys="[getMenuKey(this.$route.path)]"
      :selectedKeys="[getMenuKey(this.$route.path)]"
      :defaultOpenKeys="[0]"
      id="dashboard-sidemenu"
      v-if="menuItems"
    >
      <a-menu-item :key="1000"
        @click="()=> collapsed = !collapsed">
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
        />
        <span>Collapse</span>
      </a-menu-item>
      <a-sub-menu
        v-for="( subMenuItem, index ) in subMenu"
        :key="index"
        v-show="! subMenuItem.hide && userDetails.activated_by_admin !== 'no'
        || subMenuItem.name === 'Profile' || userDetails.user_role === 'telas_telas_administrator'">
        <span slot="title">
          <a-icon :type="subMenuItem.icon" />
          <span>
            {{subMenuItem.name}}
          </span>
        </span>
        <a-menu-item :key="getMenuKey(menuItem.routerLink)"  v-for="( menuItem ) in subMenuItem.subMenu">
          <a-icon :type="menuItem.icon"/>
            <span>{{menuItem.name}}</span>
          <router-link :to="menuItem.routerLink"></router-link>
        </a-menu-item>
      </a-sub-menu>
      <a-menu-item
      :key="getMenuKey(menuItem.routerLink)"
      v-for="( menuItem ) in indMenuItems"
      v-show="! menuItem.hide && userDetails.activated_by_admin !== 'no'
      || menuItem.name === 'Profile' || userDetails.user_role === 'telas_telas_administrator'" >
          <a-icon :type="menuItem.icon"/>
            <span>{{menuItem.name}}</span>
        <router-link :to="menuItem.routerLink"></router-link>
      </a-menu-item>
    </a-menu>
  </a-layout-sider>
</template>
<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'dash-sidebar',
  data() {
    return {
      selectedMenu: 0,
      collapsed: false,
    };
  },
  props: {
    defaultSelectedKeys: String,
    menuItems: Array,
    defaultSelectedSubKey: {
      type: String,
      default: '',
    },
  },
  methods: {
    showMenuItem() {
    },
    getMenuKey(routerLink) {
      const routerLinkArray = routerLink.split('/');
      return routerLinkArray.filter(e => e).join('-');
    },
  },
  created() {
    this.selectedMenu = this.defaultSelectedKeys;
  },
  computed: {
    ...mapGetters('user', {
      userRole: 'getUserRole',
    }),
    ...mapState('user', {
      userDetails: state => state.userDetails,
    }),
    indMenuItems() {
      const menuArray = Object.values(this.menuItems);
      let menuOnly = [];
      if (this.userRole === 'telas_interim_reviewers') {
        menuOnly = menuArray.filter(element => element.subMenu === undefined && (!element.hideForIr));
      } else {
        menuOnly = menuArray.filter(element => element.subMenu === undefined);
      }
      return menuOnly;
    },
    subMenu() {
      const menuArray = Object.values(this.menuItems);
      const subMenu = menuArray.filter(element => element.subMenu !== undefined);
      return subMenu;
    },
  },
};
</script>
<style scoped lang="css">
#dashboard-sidemenu a {
  color: #e6e4e4
}
#dashboard-sidemenu a:hover {
  color: #ffff;
}
</style>
